import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

const SkeletonCard = ({ count = 6 }) => {
	return (
		<div className="row" role="status" aria-live="polite">
			<span className="sr-only">Loading incentives...</span>
			{Array.from({ length: count }, (_, i) => (
				<div key={i} className="col-md-4 col-sm-6 col-xs-12">
					<div
						className="card skeleton-card p-3 h-100 overflow-hidden"
						aria-hidden="true"
					>
						<Skeleton aspectRatio="4by3" skeletonClasses="mb-3" />
						<Skeleton height="20px" skeletonClasses="mb-2" />
						<Skeleton height="16px" skeletonClasses="mb-2" />
						<Skeleton height="16px" skeletonClasses="mb-3" />
						<Skeleton height="36px" />
					</div>
				</div>
			))}
		</div>
	);
};

SkeletonCard.propTypes = {
	count: PropTypes.number
};

export default SkeletonCard;
